// Default Liveblocks mention character
export const MENTION_CHARACTER = "@";
